import { AuthenticationProvider, ThirdPartyProvider } from 'graphql-ts-types';

import { GOOGLE_CLIENT_ID } from '../../../login-form/components/ThirdParty/hooks/google-sign-in';

export const getAuthenticationProvider = (
  authProvider: ThirdPartyProvider
): AuthenticationProvider => {
  switch (authProvider) {
    case ThirdPartyProvider.Apple:
      return AuthenticationProvider.Apple;
    case ThirdPartyProvider.Google:
      return AuthenticationProvider.Google;
  }
};

export const generateGoogleOAuthUrl = (csrfToken: string, redirectUri: string) => {
  const finalRedirectUri = `${window.location.origin}${window.location.pathname}`;
  const stateParam = csrfToken + '|' + finalRedirectUri;

  const url = new URL('https://accounts.google.com/o/oauth2/v2/auth');
  url.searchParams.append('prompt', 'consent');
  url.searchParams.append('scope', 'openid email profile');
  url.searchParams.append('response_type', 'code');
  url.searchParams.append('client_id', GOOGLE_CLIENT_ID);
  url.searchParams.append('redirect_uri', redirectUri);
  url.searchParams.append('state', stateParam);

  return url.toString();
};
